/**
 * @file
 *
 */
function updateGlobalCart(shopifyCartObject) {
  //   console.log('updateGlobalCart:shopifyCartObject', shopifyCartObject);
  // var apiBaseUrl = $('body').attr('data-api-base');

  // $.ajax({
  //   type: 'POST',
  //   url: apiBaseUrl + '/storage/set?token=ip',
  //   data: {
  //     key: 'customer_cart',
  //     value: shopifyCartObject,
  //   },
  //   dataType: "json",
  //   success: function (data) {

  //   },
  //   error: function (jqXHR, textStatus) {
  //     console.log('Error retrieving cart: ' + cartId, err);
  //     callback(err);
  //   }
  // });
}

function forceUpdateGlobalCart() {
  //   console.log('updateGlobalCart:shopifyCartObject', shopifyCartObject);
  // var apiBaseUrl = $('body').attr('data-api-base');

  // $.ajax({
  //   type: 'GET',
  //   url: '/cart.js',
  //   dataType: "json",
  //   success: function (data) {
  //     $.ajax({
  //       type: 'POST',
  //       url: apiBaseUrl + '/storage/set?token=ip',
  //       data: {
  //         key: 'customer_cart',
  //         value: data,
  //       },
  //       dataType: "json",
  //       success: function (data) {
  //         console.log('forceUpdateGlobalCart:data', data);
  //         // if(data.dynamicToken){
  //         //   updateIMGDrupalCart(data.dynamicToken);
  //         // }

  //       },
  //       error: function (jqXHR, textStatus) {
  //         console.log('Error retrieving cart: ' + cartId, err);
  //         callback(err);
  //       }
  //     });
  //   },
  //   error: function (jqXHR, textStatus) {
  //     console.log('Error retrieving cart: ' + cartId, err);
  //     callback(err);
  //   }
  // });
}